class DropdownWidthAdjuster {
  constructor(dropdownSelector, listSelector) {
    this.dropdown = dropdownSelector;
    this.list = this.dropdown.querySelectorAll(listSelector);

    this.adjustWidth();
    this.addListeners();
  }

  adjustWidth() {
    if (this.dropdown && this.list.length > 0) {
      const dropdownWidth = this.dropdown.offsetWidth;
      this.list.forEach((listElement) => {
        listElement.style.width = `${dropdownWidth}px`;
      });
    }
  }

  addListeners() {
    window.addEventListener("resize", () => this.adjustWidth());
  }
}

function initializeDropdownAdjuster() {
  document
    .querySelectorAll(".iti--allow-dropdown")
    .forEach((dropdownElement) => {
      new DropdownWidthAdjuster(dropdownElement, ".iti__country-list");
    });
}

// Delay execution to ensure elements are loaded - Marketo forms take a little to fully load
setTimeout(initializeDropdownAdjuster, 2000);
